import type {
	Material,
	ProductTextileSustainableComposition,
} from 'product/types/ProductDetails'
import {
	type Quality,
	type QualityType,
	textileSustainableMap,
} from '../../components/Qualities/constants'
import { getQuality } from '../getQuality/getQuality'

export interface QualityData {
	id: string
	title: string
	subtitle: string
	type: QualityType
	percent: number
}

export const getQualities = (
	textileDetailComposition?: Record<
		string,
		ProductTextileSustainableComposition
	>
): QualityData[] => {
	if (!textileDetailComposition) {
		return []
	}

	const _compositionData: ProductTextileSustainableComposition =
		textileDetailComposition[textileSustainableMap.Composition]

	return (
		_compositionData?.materials
			.reduce((acc: QualityData[], material: Material) => {
				const quality: Quality | null = getQuality(material)
				if (!quality) {
					return acc
				}
				const _m: QualityData = {
					id: material.id,
					title: quality.title,
					percent: material.percent,
					subtitle: quality.subtitle,
					type: quality.type,
				}
				return acc.concat(_m)
			}, [])
			// Sort sustainable qualities first
			.sort((a: QualityData, b: QualityData) => a.type - b.type)
	)
}
